// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3fF5O","content":"RecentSearches_content__5ATtY"};